export const LAUNCH_STEPS = {
    WELCOME: 0,
    CONTACT: 1,
    CAMPAIGN_GOAL: 2,
    PROMOTION_TYPE: 3,
    MESSAGE: 4,
    UPLOAD: 5,
    PREVIEW: 6,
    VERIFY: 7,
    PREPARING: 8,
    CHECKOUT: 9,
    SUCCESS: 10,
};

/** Bars shown at the top — one per user-facing screen (not transient loading/success states). */
export const PROGRESS_STEPS = [
    'Welcome',
    'Contact',
    'Goals',
    'Promotion',
    'Message',
    'Upload',
    'Preview',
    'Verify',
    'Checkout',
];

export const CAMPAIGN_GOAL_OPTIONS = [
    { value: 'brand_awareness', label: 'Brand awareness' },
    { value: 'local_foot_traffic', label: 'Local foot traffic' },
    { value: 'product_launch', label: 'Product launch' },
    { value: 'seasonal_promotion', label: 'Seasonal promotion' },
    { value: 'other', label: 'Other' },
];

export const PROMOTION_TYPE_OPTIONS = [
    { value: 'grand_opening', label: 'Grand opening' },
    { value: 'sale_discount', label: 'Sale / discount' },
    { value: 'new_product', label: 'New product' },
    { value: 'hiring', label: 'Hiring' },
    { value: 'brand_awareness', label: 'Brand awareness' },
    { value: 'other', label: 'Other' },
];

export const LAUNCH_LEAD_ID_KEY = 'launch_lead_id';

/** Maps internal currentStep to PROGRESS_STEPS index. */
export function getLaunchProgressIndex(step) {
    switch (step) {
        case LAUNCH_STEPS.WELCOME:
            return 0;
        case LAUNCH_STEPS.CONTACT:
            return 1;
        case LAUNCH_STEPS.CAMPAIGN_GOAL:
            return 2;
        case LAUNCH_STEPS.PROMOTION_TYPE:
            return 3;
        case LAUNCH_STEPS.MESSAGE:
            return 4;
        case LAUNCH_STEPS.UPLOAD:
            return 5;
        case LAUNCH_STEPS.PREVIEW:
            return 6;
        case LAUNCH_STEPS.VERIFY:
            return 7;
        case LAUNCH_STEPS.PREPARING:
            return 8;
        case LAUNCH_STEPS.CHECKOUT:
            return 8;
        case LAUNCH_STEPS.SUCCESS:
            return PROGRESS_STEPS.length;
        default:
            return 0;
    }
}

export function getProgressStepNumber(step) {
    const idx = getLaunchProgressIndex(step);
    if (idx >= PROGRESS_STEPS.length) {
        return PROGRESS_STEPS.length;
    }
    return idx + 1;
}
